import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  currentEnvironment: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/learningContent/vuex/index.js